import { getClient } from '@/lib/restClient';
import { MenuManagementBrandItemService } from '@/services/BrandItem/MenuManagementItemService';

export const useMenuManagementDeleteBrandItem = async (
  id: string
): Promise<void> => {
  const menuManagementBrandItemService = new MenuManagementBrandItemService(
    getClient()
  );

  return menuManagementBrandItemService.delete(id);
};
